<template>
  <base-card :loading="loading" class="rounded-lg">
    <v-tabs v-model="tab" show-arrows class="rounded-t-lg" height="36px">
      <v-tab
        v-for="tab in tabsFiltered"
        class="rounded-t-lg"
        :key="tab.component"
      >
        <v-icon left small>{{ tab.icon }}</v-icon>
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" :touchless="tabsFiltered[tab]?.touchless">
      <v-tab-item v-for="item in tabsFiltered" :key="item.name" class="pt-2">
        <component :is="item.component" class="px-4 pb-4" />
      </v-tab-item>
    </v-tabs-items>
    <!-- Navgation  -->
    <v-bottom-sheet
      v-model="navigationSheet"
      inset
      max-width="550px"
      :overlay-opacity="0.8"
      content-class="elevation-0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          dark
          style="position: fixed; bottom: 76px; right: 16px; z-index: 5"
          float
          v-bind="attrs"
          v-on="on"
          color="primary"
        >
          <v-icon> mdi-dots-grid </v-icon>
        </v-btn>
      </template>
      <div class="mb-4 px-4 d-flex">
        <v-card class="pa-3 pb-1 rounded-lg flex-grow-1">
          <v-row dense class="mx-0">
            <v-col
              v-for="tab in tabsFiltered"
              :key="tab.id"
              cols="4"
              sm="4"
              md="3"
            >
              <v-card
                @click="selectTab(tab.id)"
                outlined
                height="90px"
                elevation="0"
                class="pa-2"
              >
                <div
                  class="d-flex align-center justify-center flex-column h-full text-center lh-1 gap-2"
                >
                  <v-icon>{{ tab.icon }}</v-icon>
                  {{ tab.name }}
                </div>
              </v-card>
            </v-col>
          </v-row>
          <div class="d-flex justify-center">
            <v-btn @click="navigationSheet = false" text small> Fechar </v-btn>
          </div>
        </v-card>
      </div>
    </v-bottom-sheet>
  </base-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import RepostsMonths from "@/components/admin/financial/RepostsMonths.vue";
import Calendar from "@/components/admin/financial/Calendar.vue";
import Exporter from "@/components/admin/financial/Exporter.vue";
// import RepostsGeneral from "@/components/admin/financial/RepostsGeneral.vue";
// import RepostsByPlatform from "@/components/admin/financial/RepostsByPlatform.vue";
// import RepostsByParty from "@/components/admin/financial/RepostsByParty.vue";

export default {
  metaInfo() {
    return { title: `Relatorios` };
  },
  data: () => ({
    loading: false,
    tab: null,
    navigationSheet: false,
    tabs: [
      {
        id: "calendar",
        name: "Calendário",
        component: "Calendar",
        icon: "mdi-calendar-month",
      },
      {
        id: "months",
        name: "Resumo Mensal",
        component: "RepostsMonths",
        icon: "mdi-calendar-month",
      },
      {
        id: "exporter",
        name: "Exportar",
        component: "Exporter",
        icon: "mdi-export",
      },
      // {
      //   id: "general",
      //   name: "Geral",
      //   component: "RepostsGeneral",
      //   icon: "mdi-information",
      // },
      // {
      //   id: "platform",
      //   name: "Por Plataforma",
      //   component: "RepostsByPlatform",
      //   icon: "mdi-monitor",
      // },
      // {
      //   id: "party",
      //   name: "Por Evento",
      //   component: "RepostsByParty",
      //   icon: "mdi-party-popper",
      // },
    ],
  }),
  methods: {
    selectTab(tab) {
      if (tab) window.location.replace("#" + tab);
      if (this.$route.hash) {
        let hash = tab || this.$route.hash.replace("#", "");
        let index = this.tabsFiltered.findIndex((tab) => tab.id == hash);
        if (index >= 0) this.tab = index;
        this.navigationSheet = false;
      }
    },
    vibrate() {
      if (navigator.vibrate) navigator.vibrate(50);
    },
  },
  computed: {
    ...mapGetters("auth", ["hasPermission"]),
    tabsFiltered() {
      return this.tabs.filter(
        (tab) => !tab.permission || this.hasPermission(tab.permission)
      );
    },
  },
  watch: {
    tab: {
      handler(val, oldVal) {
        if (val !== null && oldVal !== null) this.vibrate();
        let tab = this.tabsFiltered[val];
        if (tab) window.location.replace("#" + tab.id);
      },
      immediate: true,
    },
    "$route.hash"() {
      this.selectTab();
    },
  },
  components: {
    // RepostsGeneral,
    // RepostsByPlatform,
    // RepostsByParty,
    RepostsMonths,
    Exporter,
    Calendar,
  },
  mounted() {},
};
</script>

<style></style>
